/* eslint-disable no-invalid-this */
import $ from 'jquery';
import authentication from './authentication';
import { parseQueryString } from '../../smartpak/url';
import page from '../../smartpak/page';
import { login as reCaptchaLogin } from '../../vendor/recaptcha/recaptcha';

const { checkIfAuthenticationIsRequired, logout } = authentication;

export const errorCodes = {
    LOGIN_FAILED: 2,
    LOGIN_FAILED_LONG: 3,
    LOGIN_FAILED_AMBIGUOUS: 4,
    TOO_MANY_ATTEMPTS: 5
};

export function getErrorMessageFromCode(code) {
    if (code === errorCodes.LOGIN_FAILED) {
        return 'Invalid password/email.';
    }

    if (code === errorCodes.LOGIN_FAILED_LONG) {
        return 'There was a problem with this email address/password combination. Please try again, or <a href="/content/contactus">contact us</a> for assistance.';
    }

    if (code === errorCodes.LOGIN_FAILED_AMBIGUOUS) {
        return 'Logged in as multiple customers.';
    }

    if (code === errorCodes.TOO_MANY_ATTEMPTS) {
        return 'We see that you are having trouble logging in. To help keep your SmartPak account safe and secure, <a href="/reset-my-password-request">please click here to confirm your email address and reset your password</a>.';
    }

    return 'An unknown error occurred.';
}

const loginForm = {
    validate: function (data, success) {
        $.post('/account/jsonlogin', data)
            .done(response => {
                if (!response.loginSuccessful) {
                    this.showErrorMessage(getErrorMessageFromCode(response.loginState));
                    return;
                }                

                if (smartPak.cdProfileCookie && smartPak.dynamicYield) {
                    smartPak.cdProfileCookie.refreshCookieData();
                    smartPak.dynamicYield.audienceEvent(smartPak.cdProfileCookie, true);
                    smartPak.dynamicYield.loginEvent(smartPak.cdProfileCookie.CustomerEmail);
                }

                if (typeof success === 'function') {
                    success(response.customerChanged);
                }
            })
            .fail(function () {
                window.location.href = '/';
            });
    },
    parseQueryString: query => parseQueryString(query),
    showErrorMessage: function (errorMessage) {
        var $loginForm = $('#loginForm'),
            $summary = $loginForm.find('.validation-summary-valid, .validation-summary-errors').eq(0);

        $summary
            .removeClass('validation-summary-valid validation-summary-errors')
            .addClass('validation-summary-errors');

        $summary
            .find('ul')
            .empty()
            .append('<li>' + errorMessage + '</li>');
    },
    _cleanPassword: function () {
        var $password = $('#Password'),
            val = $password.val();

        if (val) {
            $password.val(val.trim());
        }
    },
    _clearErrors: function ($form) {
        $form.data('validator').resetForm();
        $form
            .find('.validation-summary-errors')
            .removeClass('validation-summary-errors')
            .addClass('validation-summary-valid');
    },
    defaultSubmit: function () {
        var search = this.parseQueryString(location.search),
            DEFAULT_URL = '/',
            returnUrl = null;

        if (search) {
            if (search.returnUrl) {
                returnUrl = search.returnUrl;
            } else if (search.ReturnUrl) {
                returnUrl = search.ReturnUrl;
            }
        }

        page.redirectToUrl(search && returnUrl ? decodeURIComponent(returnUrl) : DEFAULT_URL);
    },
    bindEvents: function () {
        this.$container
            .on('click', '#login', event => {
                event.preventDefault();
                this._cleanPassword();
                this.handleSubmitBtnClick($(event.target));
            })
            .on('click', '#register', event => {
                event.preventDefault();
                this.handleRegisterBtnClick($(event.currentTarget));
            })
            .on('keydown', '#UserName, #Password', event => {
                this._handleEnterKeyPress(event.keyCode ? event.keyCode : event.which);
            })
            .on('focus', '#UserName, #Password', () => {
                this._clearErrors(this.$form);
            })
            .on('click', '#forgotPW', event => {
                this.handleForgotPWClick(event);
            })
            .on('click', '.pwd-toggle-show', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'text');
                $(this).addClass('jsHide');
                $('.pwd-toggle-hide').removeClass('jsHide');
            })
            .on('click', '.pwd-toggle-hide', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'password');
                $(this).addClass('jsHide');
                $('.pwd-toggle-show').removeClass('jsHide');
            });
    },
    _handleEnterKeyPress: function (keyCode) {
        var ENTERKEYCODE = 13;

        if (keyCode === ENTERKEYCODE) {
            this.$formSubmitBtn.trigger('click');
        }
    },
    _addCapsLockWarning: function ($inputElements, Tooltip) {
        if (!$inputElements.length || page.isMobile()) {
            return;
        }

        $inputElements.each(function (i, element) {
            const tooltip = new Tooltip(element, {
                trigger: 'Manual',
                content: 'Caps Lock is on.',
                showOnFocus: false
            });

            element.addEventListener('keydown', e => {
                // eslint-disable-next-line no-console
                if (e.getModifierState && e.getModifierState('CapsLock')) {
                    tooltip.show();
                } else {
                    tooltip.hide();
                }
            });

            element.addEventListener('blur', () => {
                tooltip.hide();
            });
        });
    },
    handleSubmitBtnClick: async function () {
        this.$form.find('#HasPassword').val('true'); // no idea why this is required.        

        const submit = () => {
            this.validate(
                this.$form.serialize(),
                () => this.onSuccess(),
                () => this.onFailure()
            );
        };

        if (this.$form.valid()) {
            const token = await reCaptchaLogin();

            this.$form.find('#Token').val(token);
            submit();
        }
    },
    handleRegisterBtnClick: function ($button) {
        var href = $button.attr('href');

        function notAuthenticated() {
            page.redirectToUrl(href);
        }

        function authenticated() {
            logout(notAuthenticated);
        }

        /* if logged in logout before continuing */
        checkIfAuthenticationIsRequired(authenticated, notAuthenticated);
    },
    handleForgotPWClick: function (event) {
        event.preventDefault();

        if (window.sessionStorage) {
            sessionStorage.setItem('userEmail', $('#UserName').val());
        }

        page.redirectToUrl($(event.currentTarget).attr('href'));
    },
    setupFormValidation: function () {
        if ($?.validator?.unobtrusive?.parse) {
            $.validator.unobtrusive.parse(this.$container);
            return;
        }

        import('../../validation/unobtrusive')
            .then(() => $.validator.unobtrusive.parse(this.$container));
    },
    init: function (success, fail) {
        // eslint-disable-next-line no-empty-function
        this.onFailure = typeof fail === 'function' ? fail : function () { };
        this.onSuccess = typeof success === 'function' ? success : this.defaultSubmit;
        this.$container = $('#loginModule');
        this.$form = this.$container.find('#loginForm');
        this.$formSubmitBtn = this.$form.find('#login');
        this.setupFormValidation();
        this.bindEvents();
        import('../../smartpak/tooltip').then(({ Tooltip, tooltip }) => {
            this._addCapsLockWarning($('#UserName, #Password'), Tooltip);
            tooltip($('.hint'), {});
        });
    }
};

export default loginForm;
